// client/src/pages/Admin/ResourceManager/components/ResourceEmptyState.tsx

import React from 'react';
import { FileText, Plus } from 'lucide-react';

interface ResourceEmptyStateProps {
  hasActiveFilters: boolean;
  onNewResource: () => void;
}

export const ResourceEmptyState: React.FC<ResourceEmptyStateProps> = ({
  hasActiveFilters,
  onNewResource
}) => {
  return (
    <div className="empty-state" role="status">
      <div className="empty-state-icon">
        <FileText size={64} />
      </div>
      <h3 className="empty-state-title">
        {hasActiveFilters
          ? 'No resources match your filters'
          : 'No resources yet'}
      </h3>
      <p className="empty-state-description">
        {hasActiveFilters
          ? 'Try adjusting your search or filter criteria'
          : 'Create your first resource to get started'}
      </p>
      <button
        type="button"
        className="btn-primary"
        onClick={onNewResource}
        aria-label="Create your first resource"
      >
        <Plus size={18} />
        Create Resource
      </button>
    </div>
  );
};